import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faPlus } from "@fortawesome/free-solid-svg-icons";
import "./Flashcards.css";

const Flashcards = ({
  cards = [],
  onChange,
  isStudentView = false,
  border,
}) => {
  const [localCards, setLocalCards] = useState(cards);
  const [flippedCards, setFlippedCards] = useState({});

  useEffect(() => {
    setLocalCards(cards);
  }, [cards]);

  const handleAddCard = () => {
    if (localCards.length >= 3) return;
    const newCards = [...localCards, { front: "", back: "" }];
    setLocalCards(newCards);
    onChange({ cards: newCards });
  };

  const handleCardChange = (index, side, value) => {
    const newCards = [...localCards];
    newCards[index] = { ...newCards[index], [side]: value };
    setLocalCards(newCards);
    onChange({ cards: newCards });
  };

  const flipAllCards = () => {
    const newFlippedState = {};
    // Initialize all cards with the same flipped state
    localCards.forEach((_, index) => {
      // If any card is not flipped, we'll flip all cards
      // If all cards are flipped, we'll unflip all cards
      const shouldFlip = !Object.values(flippedCards).every((value) => value);
      newFlippedState[index] = shouldFlip;
    });
    setFlippedCards(newFlippedState);
  };

  const handleCardClick = (e, index) => {
    if (!e.target.closest("textarea")) {
      setFlippedCards((prev) => ({
        ...prev,
        [index]: !prev[index],
      }));
    }
  };

  return (
    <div className={`flashcards-wrapper ${border}`}>
      <div className={`flashcards-grid cards-${localCards.length}`}>
        {localCards.map((card, index) => (
          <div
            key={index}
            className={`flashcard ${flippedCards[index] ? "flipped" : ""}`}
            onClick={(e) => handleCardClick(e, index)}
          >
            <div className="flashcard-inner">
              <div className="fc-front">
                {isStudentView ? (
                  <div className="card-content">{card.front}</div>
                ) : (
                  <textarea
                    value={card.front}
                    onChange={(e) =>
                      handleCardChange(index, "front", e.target.value)
                    }
                    placeholder="Front side text"
                  />
                )}
              </div>
              <div className="fc-back">
                {isStudentView ? (
                  <div className="card-content">{card.back}</div>
                ) : (
                  <textarea
                    value={card.back}
                    onChange={(e) =>
                      handleCardChange(index, "back", e.target.value)
                    }
                    placeholder="Back side text"
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flashcard-controls">
        <button onClick={flipAllCards} className="shuffle-button">
          <FontAwesomeIcon icon={faRotate} />
        </button>
        {!isStudentView && localCards.length < 3 && (
          <button onClick={handleAddCard} className="add-card-button">
            <FontAwesomeIcon icon={faPlus} />
          </button>
        )}
      </div>
    </div>
  );
};

export default Flashcards;
